const SUPABASE_URL = 'https://wvunsvopuoqjidjqvvop.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_6wvtUeKaOpZz4a-odtChww_A4fusP2A';

let supabaseClient = null;
let initializationInProgress = false;

const apiUrl = window.SUMMIT_CHECKOUT_CONFIG?.backendBaseUrl;

// Global session state
window.supabaseSession = {
  session: null,
  user: null,
  isAuthenticated: false
};

// Custom event for session changes
const SESSION_CHANGE_EVENT = 'supabase:session-change';

function dispatchSessionChange() {
  window.dispatchEvent(new CustomEvent(SESSION_CHANGE_EVENT, {
    detail: { ...window.supabaseSession }
  }));
}

async function recoverSessionFromCheckoutBackend(client) {
  if (!client || !apiUrl) return null;

  try {
    const response = await fetch(`${apiUrl}/api/auth/getsession`, {
      method: 'GET',
      credentials: 'include'
    });

    if (!response.ok) return null;

    const payload = await response.json();
    const accessToken = payload?.data?.session?.access_token;
    const refreshToken = payload?.data?.session?.refresh_token;

    if (!accessToken || !refreshToken) return null;

    const { data, error } = await client.auth.setSession({
      access_token: accessToken,
      refresh_token: refreshToken
    });

    if (error || !data?.session) return null;
    return data.session;
  } catch (_error) {
    return null;
  }
}

async function updateSessionState(session) {
  window.supabaseSession = {
    session: session,
    user: session?.user || null,
    isAuthenticated: !!session
  };
  
  // Update UI elements
  const accountText = document.querySelector('.header__icon--account .visually-hidden');
  if (accountText) {
    accountText.textContent = session?.user?.email || 'Log in';
  }

  // If user is authenticated, fetch their orders
  // if (session?.user?.email) {
  //   await fetchUserOrders(session.user.email);
  // }
  
  dispatchSessionChange();
}

async function fetchUserOrders(email, { limit, page_info } = {}) {
  const client = initSupabase();
  if (!client) return null;
  window.supabase = client;

  try {
    const params = new URLSearchParams();
    if (limit) params.set('limit', limit);
    if (page_info) params.set('page_info', page_info);
    const qs = params.toString();
    const url = `${apiUrl}/api/shopify/get_user_orders${qs ? '?' + qs : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${window.supabaseSession.session.access_token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch orders');
    }

    const result = await response.json();

    // Store orders in the global session state
    window.supabaseSession.userOrders = result;

    // Dispatch a custom event for order updates
    window.dispatchEvent(new CustomEvent('supabase:orders-loaded', {
      detail: { orders: result }
    }));

    return result;
  } catch (error) {
    console.error('Error fetching user orders:', error);
    return null;
  }
}

function initSupabase() {
  if (initializationInProgress) return null;
  
  if (!window.supabase) {
    console.error('Supabase library not loaded');
    return null;
  }
  
  if (!supabaseClient) {
    try {
      initializationInProgress = true;
      supabaseClient = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
      window.supabaseClient = supabaseClient;

      // Check for existing session, then silently attempt checkout-cookie recovery.
      supabaseClient.auth.getSession().then(async ({ data: { session }, error }) => {
        if (error) {
          console.error('Error checking session:', error);
          return;
        }

        let resolvedSession = session;
        if (!resolvedSession) {
          resolvedSession = await recoverSessionFromCheckoutBackend(supabaseClient);
        }

        updateSessionState(resolvedSession);
      });

      // Listen for auth state changes
      supabaseClient.auth.onAuthStateChange((_event, session) => {
        updateSessionState(session);
      });

    } catch (error) {
      console.error('Failed to initialize Supabase client:', error);
      return null;
    } finally {
      initializationInProgress = false;
    }
  }
  
  return supabaseClient;
}

// Example of how to use session state in other scripts:
/*
window.addEventListener('supabase:session-change', (event) => {
  const { session, user, isAuthenticated } = event.detail;
});
*/

async function signUp(email, password) {
  const client = initSupabase();
  if (!client) {
    console.error('Supabase client not initialized');
    return { error: { message: 'Authentication service not available. Please try again later.' } };
  }

  // Validate password length
  if (password.length < 8) {
    return {
      data: null,
      error: {
        message: 'Password must be at least 8 characters long'
      }
    };
  }

  try {
    const { data, error } = await client.auth.signUp({
      email,
      password,
    });
    
    if (error) throw error;
    
    // Close the modal on successful signup
    const modal = document.getElementById('Account-Modal');
    if (modal) {
      modal.removeAttribute('open');
      modal.hidden = true;
    }
    
    return { data, error: null };
  } catch (error) {
    console.error('Sign up error:', error);
    return { 
      data: null, 
      error: { 
        message: error.message || 'Failed to sign up. Please try again.' 
      } 
    };
  }
}

async function signIn(email, password) {
  const client = initSupabase();
  if (!client) {
    console.error('Supabase client not initialized');
    return { error: { message: 'Authentication service not available. Please try again later.' } };
  }

  try {
    const { data, error } = await client.auth.signInWithPassword({
      email,
      password
    });
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Sign in error:', error);
    return { 
      data: null, 
      error: { 
        message: error.message || 'Failed to sign in. Please check your credentials and try again.' 
      } 
    };
  }
}

// Initialize when the script loads
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initSupabase, 100); // Small delay to ensure Supabase library is loaded
});
